/**
 * @(#)2019/7/1.
 * @author 飞光
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import YxButton from "./YxButton";
import config from "../../config";
import { get } from "lodash";
import PropTypes from "prop-types";

const styleParam = {
  size: PropTypes.string,
  type: PropTypes.string,
  width: PropTypes.string,
};
//类型约束
YxButton.propTypes = {
  //按钮子节点，可以是jsx，可以是其他数据
  children: PropTypes.node,

  //是否显示icon
  iconfont: PropTypes.any,

  // 按钮类型
  type: PropTypes.string,

  //存放所有的样式风格类参数
  styleParam: PropTypes.shape(styleParam),

  //输入框的参数
  inputParams: PropTypes.object,
};
//默认值
YxButton.defaultProps = {
  type: "secondary",
  size: get(config, "button.size", "default"),
  styleParam: {
    size: "primary", //样式风格-大小
    type: "", //样式风格-类型
  },
  icon: null,
  dropDown: false,
};

export default YxButton;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxButton/index.js